import React from 'react';
import '../../src/styles/SubscribeButton.css'; // Import styles

const SubscribeButton = () => {
  const handleSubscribe = () => {
    window.open("https://www.youtube.com/channel/UCMJeoG6jGrGtk3noLZ6bJMg?sub_confirmation=1", "_blank");
  };

  return (
    <button className="subscribe-button" onClick={handleSubscribe}>
      Subscribe
    </button>
  );
};

export default SubscribeButton;
